module.exports = __webpack_public_path__ + "assets/images/zoom_in.e46a5c7c97490b79aef00769f0d1c9ca.svg";